export enum FirstNameLength {
  Min = 2,
  Max = 24,
}

export enum LastNameLength {
  Min = 2,
  Max = 24,
}

export enum GenderTypes {
  Default = '',
  Male = 'male',
  Female = 'female',
}

export enum Langauges {
  Es = 'es',
  He = 'he',
  En = 'en',
  Pt = 'pt',
}

/**
 * CustomCodes enum assigns unique numeric codes to various application flows.
 * These codes are used for communicating specific scenarios to the client/caller.
 * On any modification - please ensure enum values are in sync with the backend's CustomCodes enum.
 */
export enum CustomCodes {
  /** Reservations */
  DUPLICATE_RESERVATION = 1500,
  GROUPING_ONLY_PRIVATE_RESERVATIONS = 1600,
  RESERVATION_ALREADY_GROUPED = 1700,

  /** Trips */
  MANY_LOCKED_ASSIGNMENTS = 2000,

  /** Passengers */
  PASSENGER_INVALID_DATA = 3000,

  DUPLICATE = 409,
  MONGO_DUPLICATE_KEY_ERROR = 11000,
}

export enum TableBtnFilters {
  OnlyWith,
  OnlyWithout,
  All,
}

export enum AlgorithmCodes {
  DateOrdering = 'Date Ordering',
  DynamicOrdering = 'Dynamic Ordering',
  MCMF = 'Min Cost Max Flow',
}

export enum DriverAssignmentStrategy {
  MinimumFleetUsage = 'minimumFleetUsage',
  BalanceAvailableDrivers = 'balanceAvailableDrivers',
  BalanceMinimumRequiredDrivers = 'balanceMinimumRequiredDrivers',
}

export enum DistanceTypes {
  AirDistance = 'air_distance',
  WalkingDistance = 'walking_distance',
}
